import React, { useContext } from 'react'
import { ListItemText, MenuItem, Select } from '@mui/material'
import { LanguageContext } from '../context/LanguageContext'
import langDropDownTheme from './LanguageDropDownTheme'
import config from '../common/config'


const LanguageSelector = () => {
    const { language, languages, updateLanguage } = useContext(LanguageContext)
    
    if (languages.length < 2 || config.isLanguageChangeEnabled === 'false') return null

    return (
        <Select
            value={language}
            onChange={obj => {
                const value = obj.target.value
                updateLanguage({ forcedLanguage: value })
            }}
            variant="outlined"
            sx={langDropDownTheme}
        >
            {languages.map(({ code }) => (
                <MenuItem key={code} value={code}>
                    <ListItemText primary={code?.toUpperCase()} style={{ display: 'flex' }} />
                </MenuItem>
            ))}
        </Select>
    )
}

export default LanguageSelector
